<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { PvpCardCommodity } from '../services/enum'; // 路径按你实际调整
import { usePvpCardGameStore } from '../services/gameService';

const store = usePvpCardGameStore();

const isVisible = computed(() => store.battleResult !== null);
const result = computed(() => store.battleResult!);

const titleClass = computed(() => {
    if (result.value.isTie) return 'tie';
    return result.value.isWin ? 'win' : 'lose';
});

const showDetails = ref(false);


function handleClose() {
    store.clearBattleResult();
}


// 在 BattleResult.vue 中
let autoCloseTimer: number | null = null;

watch(() => store.battleResult, (newVal) => {
    if (newVal) {
        showDetails.value = false;
        setTimeout(() => {
            showDetails.value = true;
        }, 800);
        autoCloseTimer = window.setTimeout(handleClose, 10000);
    } else {
        if (autoCloseTimer) clearTimeout(autoCloseTimer);
    }
})

</script>

<template>
    <Teleport to="body">
        <div v-if="isVisible" class="battle-result-overlay" @click="handleClose">
            <div class="result-container">
                <!-- 标题：胜利/失败/平局 -->
                <div :class="['result-title', titleClass]">
                    {{ result.isTie ? '平局' : (result.isWin ? '胜利' : '失败') }}
                </div>

                <!-- 积分变化 -->
                <transition name="fade-slide">
                    <div v-if="showDetails" class="result-details">
                        <div v-if="!result.isTie" class="score-change">
                            <span>{{ result.isWin ? '获得' : '失去' }}</span>
                            <span class="score">{{ result.isWin ? result.gain : result.gain2 }}</span>
                            <span>战魂积分</span>
                        </div>

                        <!-- 卡包奖励 -->
                        <div v-if="result.isWin && result.winnerCardPacks && result.winnerCardPacks.length > 0"
                            class="card-pack-reward">
                            <span class="pack-name" :class="pack.key" v-for="pack in result.winnerCardPacks">
                                {{ PvpCardCommodity[pack.key] }} ×1
                            </span>
                        </div>
                    </div>
                </transition>

                <!-- 跳过提示 -->
                <div class="skip-hint">点击任意位置继续</div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped lang="scss">
.battle-result-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: zoomIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.result-container {
    text-align: center;
    color: white;
    padding: 30px;
    max-width: 90%;
}

.result-title {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 24px;
    text-shadow: 0 0 10px currentColor;
    line-height: 1.2;

    &.win {
        color: #4caf50;
        text-shadow: 0 0 15px rgba(76, 175, 80, 0.7);
    }

    &.lose {
        color: #f44336;
        text-shadow: 0 0 15px rgba(244, 67, 54, 0.7);
    }

    &.tie {
        color: #9e9e9e;
        text-shadow: 0 0 10px rgba(158, 158, 158, 0.6);
    }
}

.result-details {
    margin-top: 20px;
}

.score-change {
    font-size: 20px;
    margin-bottom: 16px;

    .score {
        color: #FFD700;
        font-weight: bold;
        font-size: 24px;
        margin: 0 6px;
    }
}

.card-pack-reward {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    align-items: center;

    .pack-name {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.15);
        font-size: 16px;
        font-weight: bold;
    }



    .pack-name[class] {
        color: var(--color, #fff);
    }
}

.skip-hint {
    margin-top: 40px;
    font-size: 14px;
    color: #aaa;
    animation: pulse 1.5s infinite;
}

// 动画
@keyframes zoomIn {
    from {
        transform: scale(0.8);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes pulse {

    0%,
    100% {
        opacity: 0.4;
    }

    50% {
        opacity: 1;
    }
}

.fade-slide-enter-active {
    transition: all 0.5s ease 0.3s;
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateY(20px);
}

.fade-slide-enter-to {
    opacity: 1;
    transform: translateY(0);
}
</style>